import classNames from 'classnames';
import {BaseMap, BaseMapProps} from './BaseMap';
import {ViewerEvent} from '../events';
import {ViewerProps} from '../props';

/**
 * Názvy synchronizovaných properties specifických pro mapový zobrazovač.
 *
 * @ignore
 */
const syncedPropNames = ['tools', 'contextTools'];

/**
 * Mapový zobrazovač, který vyžaduje state na vstupu.
 *
 * @ignore
 */
export class BaseMapViewer extends BaseMap<ViewerProps, ViewerEvent> {
    /**
     * Vrátí jména properties, které synchronizujeme s mapovým serverem při změně.
     *
     * @returns Jména properties.
     */
    protected getSyncedPropNames(): string[] {
        return [...super.getSyncedPropNames(), ...syncedPropNames];
    }

    /**
     * Vrátí cestu mapové stránky v URL.
     *
     * @returns Cesta.
     */
    protected getPath(): string {
        return this.props.nativeMobile ? 'embed-native-mobile-map' : 'embed-map';
    }

    /**
     * Voláno po aktualizaci komponenty.
     *
     * @param prevProps - Předchozí properties.
     */
    componentDidUpdate(prevProps: ViewerProps & BaseMapProps<ViewerEvent>): void {
        if (prevProps.nativeMobile !== this.props.nativeMobile) {
            this.updateSrc(); // Dojde ke změně path, nutno přegenerovat URL.
        }
        super.componentDidUpdate(prevProps);
    }

    /**
     * Vykreslí komponentu.
     *
     * @returns Element.
     */
    render(): JSX.Element | null {
        const {
            className: customClassName,
            tools,
            contextTools,
            nativeMobile,
            initialTopic,
            initialBackgroundLayer,
            initialForegroundLayer,
            initialLayers,
            initialCatalogNodes,
            initialLocation,
            initialZoom,
            initialFilter,
            topicChangeEnabled,
            ...otherProps
        } = this.props;

        const className = classNames('react-mapio-map', 'react-mapio-map-viewer', customClassName);
        return this.renderFrame({className, ...otherProps});
    }
}
